import React from "react";
import { BrowserRouter } from "react-router-dom";

import Router from "./routes";
// import { AppProvider } from "./hooks";

const App: React.FC = () => (
  <BrowserRouter>
    {/* <AppProvider> */}
      <Router />
    {/* </AppProvider> */}

  </BrowserRouter>
);

export default App;